import { Avatar, Body1Strong, Button, Caption1, makeStyles, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger, tokens } from '@fluentui/react-components';
import { useAuth } from '../../hooks/useAuth';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${tokens.spacingVerticalL} ${tokens.spacingHorizontalXL}`,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground2,
    minHeight: '64px',
    boxShadow: tokens.shadow2,
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
  },
  title: {
    fontSize: '20px',
    fontWeight: 600,
    color: tokens.colorNeutralForeground1,
    lineHeight: '28px',
  },
  actions: { display: 'flex', alignItems: 'center', gap: tokens.spacingHorizontalM },
  userInfo: { display: 'flex', flexDirection: 'column' as const, alignItems: 'flex-end' },
});

export const AppHeader = () => {
  const styles = useStyles();
  const { user, logout } = useAuth();

  return (
    <header className={styles.root}>
      <div className={styles.brand}>
        <img src="/assets/cloudshift-logo.png" alt="CloudShift" style={{ height: 36 }} />
        <span className={styles.title}>CRM Partner Center</span>
      </div>
      <div className={styles.actions}>
        <div className={styles.userInfo}>
          <Body1Strong>{user?.cr_crm_fullname ?? 'Guest user'}</Body1Strong>
          <Caption1 style={{ color: tokens.colorNeutralForeground3 }}>{user?.cr_crm_email ?? 'local workspace mode'}</Caption1>
        </div>
        <Menu>
          <MenuTrigger disableButtonEnhancement>
            <Button appearance="subtle" icon={<Avatar name={user?.cr_crm_fullname ?? 'User'} size={36} />} />
          </MenuTrigger>
          <MenuPopover>
            <MenuList>
              <MenuItem onClick={() => void logout()}>Sign out</MenuItem>
            </MenuList>
          </MenuPopover>
        </Menu>
      </div>
    </header>
  );
};
